export default __webpack_public_path__ + "static/media/Shukar-ka.88bda916.jpg";